let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fkMdp")).then(() => parcelRequire('1q8gp'));